import React from "react";
import "../styles/roadmap.css";

import roadmapImage from "../assets/images/roadmap.png";

import icon1 from "../assets/icons/icon-1.svg";
import icon2 from "../assets/icons/icon-2.svg";
import icon3 from "../assets/icons/icon-3.svg";
import icon4 from "../assets/icons/icon-4.svg";
import icon5 from "../assets/icons/icon-5.svg";

const Roadmap = () => {
  const phases = [
    {
      phase: "Phase 1",
      icon: icon1,
      title: "Hotel Booking MVP",
      quarter: "Q3",
      year: "2026",
    },
    {
      phase: "Phase 2",
      icon: icon2,
      title: "Crypto Payment Integration",
      quarter: "Q4",
      year: "2026",
    },
     {
      phase: "Phase 3",
      icon: icon3,
      title: "Flight Booking & Mining Launching",
      quarter: "Q2",
      year: "2027",
    },
    {
      phase: "Phase 4",
      icon: icon4,
      title: "Delay Insurance Launch",
      quarter: "Q3",
      year: "2027",
    },
    
  ];

  return (
    <section className="roadmap-section" id="roadmap">
      <div className="container">

        <div className="roadmap-card">

          <div className="row">

            {/* Left */}

            <div className="col-lg-5">

              <div className="roadmap-left">

                <h2>04 ROADMAP</h2>

                <p>
                  Building the future of TravelFi.
                </p>

               <div className="text-center">
                 <img
                  src={roadmapImage}
                  alt=""
                  className="roadmap-character"
                />
               </div>

              </div>

            </div>

            {/* Right */}

            <div className="col-lg-7">

              <div className="roadmap-grid">

                {phases.map((item, index) => (
                  <div
                    className="phase-card"
                    key={index}
                  >

                    <div className="phase-header">
                      {item.phase}
                    </div>

                    <div className="phase-date">
                      <span>{item.quarter}</span>
                      <span>{item.year}</span>
                    </div>

                    <img
                      src={item.icon}
                      alt=""
                    />

                    <h4>
                      {item.title}
                    </h4>

                  </div>
                ))}

                {/* Phase 5 */}

                <div className="phase-card phase-5">

                  <div className="phase-header">
                    Phase 5
                  </div>

                  <div className="phase-date">
                    <span>Q4</span>
                    <span>2027</span>
                  </div>

                  <img
                    src={icon5}
                    alt=""
                  />

                  <h4>
                    AI Travel Score & Global Expansion
                  </h4>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default Roadmap;